import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { WindowTitle } from '@homeviews/shared-ui'

import type { ITheme } from '@homeviews/styles'
import { DevelopmentEditForm } from '@homeviews/developments'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      padding: theme.spacing(
        theme.layout.contentHorizontalPadding,
        theme.layout.contentVerticalPadding,
      ),
    },
  }),
)
const Development: React.FC = () => {
  const classes = useStyles()
  return (
    <>
      <WindowTitle title="Development Edit" />
      <div className={classes.root}>
        <DevelopmentEditForm />
      </div>
    </>
  )
}

export default Development
